import { B3Propagator } from '@opentelemetry/propagator-b3';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
// import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
// import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
// import { ZoneContextManager } from '@opentelemetry/context-zone';

import packageInfo from 'package.json';

const provider = new WebTracerProvider({
  resource: new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: 'missingno-cms',
    [SemanticResourceAttributes.SERVICE_NAMESPACE]: 'missingno',
    [SemanticResourceAttributes.SERVICE_VERSION]: packageInfo.version,
    'git.repository_url': process.env.REPOSITORY,
    'git.commit.sha':
      process.env.GIT_COMMIT_SHA ||
      process.env.NEXT_PUBLIC_GIT_COMMIT_SHA ||
      'development',
  }),
});

if (process.env.NEXT_PUBLIC_OTEL_EXPORTER_URL) {
  provider.addSpanProcessor(new BatchSpanProcessor(new OTLPTraceExporter()));
}

provider.register({
  // FIXME: Right now the ZoneAwarePromise implem breaks nextjs.
  // contextManager: new ZoneContextManager(),
  propagator: new B3Propagator(),
});

// FIXME: Right now the fetch instrumentation breaks next-auth
// registerInstrumentations({
//   instrumentations: [getWebAutoInstrumentations()],
// });
